import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceTableComponent } from './invoice-table/invoice-table.component';
import { RouterModule } from '@angular/router';
import { InvoiceTableFilterComponent } from './invoice-table-filter/invoice-table-filter.component';
import { InvoicesPageComponent } from './invoices-page/invoices-page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material/material.module';
import { InvoiceViewComponent } from './invoice-view/invoice-view.component';

@NgModule({
    exports: [
        InvoiceTableComponent,
        InvoiceTableFilterComponent,
        InvoicesPageComponent,
        InvoiceViewComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        MaterialModule,
        InvoiceTableComponent,
        InvoiceTableFilterComponent,
        InvoicesPageComponent,
        InvoiceViewComponent
    ]
})
export class InvoicesModule { }
